import { IconoX } from './IconosWiki'
import { useSesion } from '../hooks/useSesion'

/** Aviso flotante cuando useCierreSesionPorInactividad cerró la sesión. */
function AvisoSesionExpirada() {
  const { sesionExpirada, descartarAvisoExpiracion } = useSesion()
  if (!sesionExpirada) return null

  return (
    <div
      role="alert"
      className="fixed inset-x-4 top-[calc(var(--altura-encabezado)+0.75rem)] z-50 mx-auto flex max-w-md items-start justify-between gap-4 rounded-sm border border-oro-profundo bg-leopardo px-4 py-3 text-sm text-marfil shadow-lg shadow-noche/50 sm:inset-x-auto sm:right-6"
    >
      <p>Tu sesión se cerró por inactividad. Inicia sesión de nuevo para continuar.</p>
      <button
        type="button"
        onClick={descartarAvisoExpiracion}
        aria-label="Cerrar aviso"
        className="area-tactil -m-2 shrink-0 rounded-sm p-2 text-marfil-suave transition-colors hover:text-oro-claro"
      >
        <IconoX className="size-4" />
      </button>
    </div>
  )
}

export default AvisoSesionExpirada
